import React from 'react';
import { usePermissions } from '../../contexts/PermissionContext';

export const PermissionGate = ({ 
  permission, 
  permissions, 
  requireAll = false,
  children, 
  fallback = null 
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions, loading } = usePermissions();

  if (loading) {
    return null;
  }

  let hasAccess = false;

  if (permission) {
    hasAccess = hasPermission(permission);
  } else if (permissions && permissions.length > 0) {
    hasAccess = requireAll 
      ? hasAllPermissions(permissions) 
      : hasAnyPermission(permissions);
  } else {
    hasAccess = true;
  }

  return hasAccess ? children : fallback;
};

export const withPermission = (WrappedComponent, permission, fallback = null) => {
  return function PermissionWrapper(props) {
    return (
      <PermissionGate permission={permission} fallback={fallback}>
        <WrappedComponent {...props} />
      </PermissionGate>
    );
  };
};

export const MenuPermissionGate = ({ menuKey, children, fallback = null }) => {
  const { canAccessMenu, loading } = usePermissions();

  if (loading) {
    return null;
  }

  return canAccessMenu(menuKey) ? children : fallback;
};

export default PermissionGate;
